// utils/validation.js

export const validateInventory = (inventory) => {
  const errors = {};
  
  if (!inventory.inventoryName.trim()) {
    errors.inventoryName = 'Please fill the Inventory Name';
  }
  
  return errors;
};

export const validateItem = (item) => {
  const errors = {};
  
  if (!item.productName.trim()) {
    errors.productName = 'Please fill the Product Name';
  }
  
  if (!item.productNo.trim()) {
    errors.productNo = 'Please fill the Product Number';
  }
  
  if (!item.quantity || parseInt(item.quantity) <= 0) {
    errors.quantity = 'Please enter a valid quantity';
  }
  
  return errors;
};

export const generateShareLink = (inventoryId) => {
  return `https://inventory-app.com/share/${inventoryId}`;
};

export const createNewInventoryData = (inventory) => {
  return {
    id: Date.now(),
    inventoryName: inventory.inventoryName,
    description: inventory.description,
    inventoryImage: inventory.inventoryImage,
    inventoryList: [],
    createdAt: new Date().toISOString()
  };
};

export const createNewItemData = (item) => {
  return {
    id: Date.now(),
    productName: item.productName,
    productNo: item.productNo,
    description: item.description,
    weight: parseFloat(item.weight) || 0,
    totalQuantity: parseInt(item.quantity),
    availableQuantity: parseInt(item.quantity),
    usedQuantity: 0,
    date: new Date().toLocaleDateString()
  };
};